var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSlpDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95358 7.97306C9.53886 8.36325 10.2404 8.59157 10.9958 8.59157C11.7555 8.59157 12.4611 8.36325 13.0464 7.97306C14.0551 7.30892 14.7234 6.16326 14.7234 4.86401C14.7234 2.80929 13.0547 1.14062 10.9958 1.14062C8.94527 1.14062 7.27661 2.80929 7.27661 4.86401C7.27661 6.16326 7.94491 7.30892 8.95358 7.97306Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8808 8.11328C13.7272 8.25027 13.5611 8.37479 13.3868 8.49101C12.6811 8.96422 11.8551 9.21329 10.9959 9.21329C10.1449 9.21329 9.31888 8.96422 8.60906 8.49101C8.43473 8.37479 8.26868 8.25027 8.11926 8.11328C6.55434 8.55328 5.39208 9.96461 5.32983 11.654H16.6702C16.6079 9.96461 15.4457 8.55328 13.8808 8.11328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6688 20.2347H17.9238L18.6544 13.5517C18.6918 13.2279 18.588 12.9041 18.368 12.6592C18.1521 12.4185 17.8366 12.2773 17.5129 12.2773H4.48721C4.16345 12.2773 3.84798 12.4185 3.63212 12.6592C3.41211 12.9041 3.30834 13.2279 3.34571 13.5517L4.07628 20.2347H3.33134C3.15947 20.2347 3.02002 20.3742 3.02002 20.546C3.02002 20.7179 3.15947 20.8574 3.33134 20.8574H4.42494H17.5752H18.6688C18.8406 20.8574 18.9801 20.7179 18.9801 20.546C18.9801 20.3742 18.8406 20.2347 18.6688 20.2347ZM11 14.3528C12.2204 14.3528 13.2125 15.3449 13.2125 16.5694C13.2125 17.7898 12.2204 18.7819 11 18.7819C9.77967 18.7819 8.78759 17.7898 8.78759 16.5694C8.78759 15.3449 9.77967 14.3528 11 14.3528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSlpDashboard);
export default __webpack_public_path__ + "static/media/ic-slp-dashboard.2b138f96cd78f7487c8cebd46b1bdb21.svg";
export { ForwardRef as ReactComponent };